"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Select = _interopRequireDefault(require("../../elements/select/Select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formValidationCountryRequired = 'Please select a country';
var COUNTRY_SELECTOR = {
  component: _Select["default"],
  name: 'countryCode',
  id: 'countryCode',
  label: 'Country',
  required: true,
  validationMessageKeys: {
    required: formValidationCountryRequired,
    notInOptions: formValidationCountryRequired
  },
  options: []
};
var _default = exports["default"] = COUNTRY_SELECTOR;